import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";

import { INVESTOR_MATURITIES, INVESTOR_BUSINESS_MODELS, INVESTOR_REGIONS, INVESTOR_SECTORS_PME, INVESTOR_SECTORS_STARTUP, BUYER_MATURITIES } from "../../../constants/investor";
import MultiSelect from "../components/Multiselect";

import api from "@/services/api";
import Loader from "@/components/Loader";

const Criteria = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/investor/${id}`);
        if (res.ok) {
          setValues(res.data);
        } else {
          toast.error("Une erreur est survenue");
        }
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };
    fetchData();
  }, [id]);

  const handleSave = async () => {
    try {
      const res = await api.put(`/investor/${id}`, { ...values, annonce_step: "CRITERIA" });
      if (res.ok) {
        navigate("/home");
        toast.success("Votre annonce a bien été sauvegardée");
      }
    } catch (error) {
      console.error(error);
      toast.error("Une erreur est survenue");
    }
  };

  const handleNext = async () => {
    try {
      const res = await api.put(`/investor/${id}`, { ...values, annonce_step: "LOGO" });
      if (res.ok) {
        navigate(`/investisseurs/${id}/create/logo`);
        toast.success("Vos données ont bien été sauvegardées");
      }
    } catch (error) {
      console.error(error);
      toast.error("Une erreur est survenue");
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="flex flex-col justify-between h-full w-full gap-6">
      {values.annonce_type === "buyer" ? (
        <h1 className="text-primary text-xl">Vos critères de reprise</h1>
      ) : (
        <h1 className="text-primary text-xl">Vos critères d'investissement</h1>
      )}
      <div className="space-y-2">
        <div className="border border-secondary rounded-lg p-5 flex flex-col gap-2">
          <label className="text-base font-medium" htmlFor="website">
            Maturité des projets
          </label>
          {values.annonce_type === "buyer" ? (
            <MultiSelect options={BUYER_MATURITIES} values={values.buyer_maturities} onSelect={(v) => setValues({ ...values, buyer_maturities: v })} />
          ) : (
            <MultiSelect options={INVESTOR_MATURITIES} values={values.maturities} onSelect={(v) => setValues({ ...values, maturities: v })} />
          )}
        </div>
        <div className="border border-secondary rounded-lg p-5 flex flex-col gap-2">
          <label className="text-base font-medium" htmlFor="website">
            Modèle économique
          </label>
          <MultiSelect options={INVESTOR_BUSINESS_MODELS} values={values.businesses} onSelect={(v) => setValues({ ...values, businesses: v })} />
        </div>

        <div className="border border-secondary rounded-lg p-5 flex flex-col gap-2">
          <label className="text-base font-medium" htmlFor="website">
            Zone géographique
          </label>
          <MultiSelect options={INVESTOR_REGIONS} values={values.regions} onSelect={(v) => setValues({ ...values, regions: v })} />
        </div>
        <div className="border border-secondary rounded-lg p-5 flex flex-col gap-2">
          <label className="text-base font-medium" htmlFor="website">
            Secteurs
          </label>
          {values.annonce_type === "buyer" ? (
            <MultiSelect options={INVESTOR_SECTORS_PME} values={values.buyer_sectors} onSelect={(v) => setValues({ ...values, buyer_sectors: v })} />
          ) : (
            <MultiSelect options={INVESTOR_SECTORS_STARTUP} values={values.sectors} onSelect={(v) => setValues({ ...values, sectors: v })} />
          )}
        </div>
      </div>

      <div className="flex right-0 bg-white items-center justify-between gap-4 w-full p-4">
        <button type="button" className="empty-button w-48" onClick={handleSave}>
          Sauvegarder et quitter
        </button>
        <div className="flex items-center gap-4">
          <Link to="../location" className="empty-button w-48">
            Précédent
          </Link>
          <button type="button" className="primary-button w-48" onClick={handleNext}>
            Suivant
          </button>
        </div>
      </div>
    </div>
  );
};

export default Criteria;
